import { render, staticRenderFns } from "./DriversSection.vue?vue&type=template&id=3dc1a2b5&scoped=true"
import script from "./DriversSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriversSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DriversSection.vue?vue&type=style&index=0&id=3dc1a2b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1a2b5",
  null
  
)

export default component.exports